module.exports = __webpack_public_path__ + "static/blue-outline-bg-75f28eaa6f4f8b71910da58e24848b01.jpg";